// React
import React, { useEffect } from 'react';
// Redux
import { Dispatch } from 'redux';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
// Actions
import { getUserSelf, logoutUser } from './../../actions/user';
// Components

// Style
import { Container, Nav, Navbar /*NavDropdown*/ } from 'react-bootstrap';
import './header.css';
import { LogoAnim } from '../Login/LogoAnim';

export const Header = (props: any) => {
	const navigate = useNavigate();
	const location = useLocation();

	const { connected, login } = useSelector((state: any) => state.user);

	const dispatch: Dispatch<any> = useDispatch();

	useEffect(() => {
		dispatch(getUserSelf());
	}, [dispatch]);

	useEffect(() => {
		if (connected && location.pathname === '/login') {
			navigate('/');
		}
	}, [connected, location.pathname, navigate]);

	return (
		<Navbar className='header' collapseOnSelect expand='lg'>
			<Container>
				<Navbar.Brand className="header-brand" onClick={() => navigate('/')}>
					<LogoAnim height={'80%'} />
					TimescopeOS - Hub
				</Navbar.Brand>
				<Navbar.Toggle aria-controls='responsive-navbar-nav' />
				<Navbar.Collapse id='responsive-navbar-nav'>
					<Nav className='me-auto'>
						{/* {connected ? (
							<React.Fragment>
								<Nav.Link onClick={() => navigate('/live')}>Live</Nav.Link>
								<Nav.Link onClick={() => navigate('/datas')}>Datas</Nav.Link>
								<Nav.Link onClick={() => navigate('/locations')}>Locations</Nav.Link>
							</React.Fragment>
						) : null} */}
					</Nav>
					<Nav>
						{connected ? (
							<div className="header-menu">
								<Nav.Link>Hello {login}</Nav.Link>
								<Nav.Link className='button-6' onClick={() => dispatch(logoutUser())}>Sign Out</Nav.Link>
							</div>
						) : (
							<React.Fragment>
								<Nav.Link onClick={() => navigate('/login')}>Login</Nav.Link>
							</React.Fragment>
						)}
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
};
